import * as React from 'react';
import Drawer from '@mui/material/Drawer';
import { Box, Typography, IconButton } from '@mui/material';
import { useLocation } from 'react-router-dom';
import SiteLink from '../global/SiteLink';
import SocialIcon from '../global/SocialIcon';
import { useSite } from '../../site/SiteContext';

// SVG Icons
const CloseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '1rem', height: '1rem' }}><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>;
const HouseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '0.875rem', height: '0.875rem' }}><path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path><path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path></svg>;
const SettingsIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '0.875rem', height: '0.875rem' }}><path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path><circle cx="12" cy="12" r="3"></circle></svg>;
const PackageIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '0.875rem', height: '0.875rem' }}><path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"></path><path d="M12 22V12"></path><polyline points="3.29 7 12 12 20.71 7"></polyline><path d="m7.5 4.27 9 5.15"></path></svg>;
const BoxIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '0.875rem', height: '0.875rem' }}><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path><path d="m3.3 7 8.7 5 8.7-5"></path><path d="M12 22V12"></path></svg>;
const BriefcaseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '0.875rem', height: '0.875rem' }}><path d="M12 12h.01"></path><path d="M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"></path><path d="M22 13a18.15 18.15 0 0 1-20 0"></path><rect width="20" height="14" x="2" y="6" rx="2"></rect></svg>;
const InfoIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '0.875rem', height: '0.875rem' }}><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>;
const MapPinIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '0.875rem', height: '0.875rem' }}><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg>;
const PhoneIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '1rem', height: '1rem' }}><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>;
const MessageIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '0.875rem', height: '0.875rem' }}><path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"></path></svg>;
const MailIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '0.875rem', height: '0.875rem' }}><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path><rect x="2" y="4" width="20" height="16" rx="2"></rect></svg>;
const DownloadIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '0.875rem', height: '0.875rem' }}><path d="M12 15V3"></path><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><path d="m7 10 5 5 5-5"></path></svg>;
const GlobeIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '0.875rem', height: '0.875rem' }}><circle cx="12" cy="12" r="10"></circle><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path></svg>;

// Menu links are managed in the dashboard; known site pages keep their icon.
const getIconForPath = (path) => {
    switch (path) {
        case '/': return <HouseIcon />;
        case '/services': return <SettingsIcon />;
        case '/products': return <PackageIcon />;
        case '/quote': return <BoxIcon />;
        case '/projects': return <BriefcaseIcon />;
        case '/about': return <InfoIcon />;
        case '/contact': return <MapPinIcon />;
        default: return <InfoIcon />;
    }
};

export default function NavDrawer({ setDrawer, drawer }) {
    const { site, locale: lng, switchLanguage } = useSite();
    const location = useLocation();
    const texts = site.layout?.drawer ?? {};
    const logo = site.brand?.logo?.url;
    const phone = site.contact?.phones?.[0];
    const profile = site.documents?.company_profile;

    return (
        <Drawer
            anchor={lng === 'en' ? 'left' : 'right'}
            open={drawer}
            onClose={() => setDrawer(false)}
            sx={{
                '& .MuiDrawer-paper': {
                    width: '80vw',
                    maxWidth: '23rem',
                    borderTopRightRadius: lng === 'ar' ? 0 : '2rem',
                    borderBottomRightRadius: lng === 'ar' ? 0 : '2rem',
                    borderTopLeftRadius: lng === 'en' ? 0 : '2rem',
                    borderBottomLeftRadius: lng === 'en' ? 0 : '2rem',
                    backgroundColor: '#ffffff',
                    padding: '14px',
                    boxShadow: '0 24px 80px -28px rgba(15,23,42,0.5)',
                    display: 'flex',
                    flexDirection: 'column',
                    overflowX: 'hidden'
                },
                '& .MuiBackdrop-root': {
                    backdropFilter: 'blur(1px)',
                    background: 'linear-gradient(90deg, rgba(255,255,255,0.05) 0%, rgba(14,24,40,0.08) 35%, rgba(14,24,40,0.18) 100%)'
                }
            }}
        >
            {/* Header */}
            <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                {lng === 'ar' && (
                    <IconButton
                        onClick={() => setDrawer(false)}
                        sx={{
                            width: 40, height: 40, borderRadius: '1rem',
                            backgroundColor: '#f1f5f9', color: '#0f172a',
                            transition: 'background-color 0.3s',
                            '&:hover': { backgroundColor: '#e2e8f0' }
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                )}

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, width: lng === 'en' ? '100%' : 'auto', justifyContent: lng === 'en' ? 'space-between' : 'flex-end' }}>
                    <Box sx={{ textAlign: lng === 'ar' ? 'right' : 'left' }}>
                        <Typography sx={{ fontSize: '1.4rem', fontWeight: 800, lineHeight: 1, color: '#0f172a' }}>
                            {texts.menu_title}
                        </Typography>
                        <Typography sx={{ mt: 0.5, fontSize: '0.58rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.18em', color: 'rgba(197, 180, 74, 0.8)' }}>
                            {texts.tagline}
                        </Typography>
                    </Box>
                    <Box sx={{
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        width: 40, height: 40, borderRadius: '1rem',
                        backgroundColor: 'rgba(197, 180, 74, 0.1)',
                        border: '1px solid rgba(197, 180, 74, 0.15)'
                    }}>
                        {logo && <img src={logo} alt={site.brand?.name} style={{ width: 32, height: 32, objectFit: 'contain' }} />}
                    </Box>
                </Box>

                {lng === 'en' && (
                    <IconButton
                        onClick={() => setDrawer(false)}
                        sx={{
                            width: 40, height: 40, borderRadius: '1rem',
                            backgroundColor: '#f1f5f9', color: '#0f172a',
                            transition: 'background-color 0.3s',
                            '&:hover': { backgroundColor: '#e2e8f0' }
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                )}
            </Box>

            {/* Navigation Links */}
            <Box component="nav" sx={{ mt: 1.5, display: 'flex', flexDirection: 'column' }}>
                {site.menus?.header?.map((page, idx) => {
                    const pagePath = page.url;
                    const isActive = !page.external && (location.pathname === pagePath || (pagePath !== '/' && location.pathname.startsWith(pagePath)));

                    return (
                        <SiteLink
                            key={idx}
                            to={pagePath}
                            newTab={page.new_tab}
                            onClick={() => setDrawer(false)}
                            style={{ textDecoration: 'none' }}
                        >
                            <Box sx={{
                                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                flexDirection: lng === 'en' ? 'row-reverse' : 'row',
                                borderBottom: '1px solid rgba(226, 232, 240, 0.7)',
                                py: 1, transition: 'all 0.3s',
                                color: isActive ? '#b8975a' : '#0f172a',
                                '&:hover': { color: '#b8975a', '& .nav-icon-bg': { backgroundColor: '#f1f5f9' } }
                            }}>
                                <Typography sx={{ fontSize: '0.88rem', fontWeight: 600, lineHeight: 1.25 }}>
                                    {page.label}
                                </Typography>
                                <Box className="nav-icon-bg" sx={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    width: 28, height: 28, borderRadius: '0.75rem',
                                    transition: 'background-color 0.3s',
                                    backgroundColor: isActive ? 'rgba(197, 180, 74, 0.12)' : '#f1f5f9',
                                    color: isActive ? '#b8975a' : 'rgba(15, 23, 42, 0.6)'
                                }}>
                                    {getIconForPath(pagePath)}
                                </Box>
                            </Box>
                        </SiteLink>
                    )
                })}
            </Box>

            {/* Banner Card */}
            <Box sx={{
                mt: 1.5, p: 1.25, borderRadius: '1.2rem',
                border: '1px solid rgba(197, 180, 74, 0.15)',
                background: 'linear-gradient(to bottom right, rgba(197, 180, 74, 0.1), #ffffff, #f1f5f9)',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexDirection: lng === 'en' ? 'row-reverse' : 'row' }}>
                    <Box sx={{
                        position: 'relative', width: 40, height: 40, borderRadius: '1rem',
                        overflow: 'hidden', backgroundColor: '#fff', border: '1px solid rgba(197, 180, 74, 0.1)', flexShrink: 0
                    }}>
                        {logo && <img src={logo} alt={site.brand?.name} style={{ width: '100%', height: '100%', objectFit: 'contain', padding: '4px' }} onError={(e) => e.target.style.display = 'none'} />}
                    </Box>
                    <Box sx={{ textAlign: lng === 'ar' ? 'right' : 'left' }}>
                        <Typography sx={{ fontSize: '0.76rem', fontWeight: 700, color: '#0f172a' }}>
                            {texts.card_title}
                        </Typography>
                        <Typography sx={{ mt: 0.25, fontSize: '0.64rem', lineHeight: 1.4, color: '#64748b' }}>
                            {texts.card_text}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* Contact Button */}
            <Box
                component="a"
                href={phone ? `tel:${phone}` : undefined}
                sx={{
                    mt: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1,
                    flexDirection: lng === 'en' ? 'row-reverse' : 'row',
                    borderRadius: '1rem', backgroundColor: '#b8975a', px: 1.75, py: 1.25,
                    textDecoration: 'none', color: '#0f172a', fontSize: '0.88rem', fontWeight: 700,
                    boxShadow: '0 18px 40px -24px rgba(183,148,24,1)',
                    transition: 'transform 0.2s',
                    '&:hover': { transform: 'scale(1.01)' }
                }}
            >
                {texts.call_label}
                <PhoneIcon />
            </Box>

            {/* Footer */}
            <Box sx={{ mt: 'auto', pt: 1.5 }}>
                <Box sx={{ borderTop: '1px solid rgba(226, 232, 240, 0.8)', pt: 1.25 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexDirection: lng === 'en' ? 'row-reverse' : 'row', width: '100%' }}>
                            <Box sx={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                width: 36, height: 36, borderRadius: '1rem',
                                backgroundColor: 'rgba(197, 180, 74, 0.1)',
                                border: '1px solid rgba(197, 180, 74, 0.15)',
                                flexShrink: 0
                            }}>
                                {logo && <img src={logo} alt="" style={{ width: 22, height: 22, objectFit: 'contain' }} />}
                            </Box>
                            <Box sx={{ textAlign: lng === 'ar' ? 'right' : 'left' }}>
                                <Typography sx={{ fontSize: '0.74rem', fontWeight: 700, color: '#0f172a' }}>
                                    {texts.stay_title}
                                </Typography>
                                <Typography sx={{ mt: 0.25, fontSize: '0.62rem', color: '#64748b' }}>
                                    {texts.stay_text}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    <Box sx={{ mt: 1.25, display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: lng === 'en' ? 'flex-start' : 'flex-end', gap: 0.75 }}>
                        {/* WhatsApp */}
                        {site.contact?.whatsapp?.url && (
                            <IconButton
                                component="a" href={site.contact.whatsapp.url} target="_blank" rel="noopener noreferrer"
                                sx={{ width: 36, height: 36, borderRadius: '1rem', backgroundColor: '#25D366', color: '#fff', '&:hover': { backgroundColor: '#25D366', transform: 'scale(1.05)' } }}
                            >
                                <MessageIcon />
                            </IconButton>
                        )}
                        {/* Email */}
                        {site.contact?.email && (
                            <IconButton
                                component="a" href={`mailto:${site.contact.email}`}
                                sx={{ width: 36, height: 36, borderRadius: '1rem', backgroundColor: '#0f172a', color: '#fff', '&:hover': { backgroundColor: '#0f172a', transform: 'scale(1.05)' } }}
                            >
                                <MailIcon />
                            </IconButton>
                        )}
                        {/* Company profile */}
                        {profile?.url && (
                            <IconButton
                                component="a" href={profile.url} target="_blank" rel="noopener noreferrer" {...(profile.type === 'pdf' && { download: true })}
                                sx={{ width: 36, height: 36, borderRadius: '1rem', backgroundColor: '#b8975a', color: '#0f172a', '&:hover': { backgroundColor: '#b8975a', transform: 'scale(1.05)' } }}
                            >
                                <DownloadIcon />
                            </IconButton>
                        )}
                        {/* Social links */}
                        {site.social?.map((link) => (
                            <IconButton
                                key={link.url}
                                component="a" href={link.url} target="_blank" rel="noopener noreferrer" aria-label={link.label}
                                sx={{ width: 36, height: 36, borderRadius: '1rem', backgroundColor: '#f1f5f9', color: '#0f172a', fontSize: '1rem', border: '1px solid #e2e8f0', '&:hover': { backgroundColor: '#e2e8f0', transform: 'scale(1.05)' } }}
                            >
                                <SocialIcon platform={link.platform} />
                            </IconButton>
                        ))}
                        {/* Language Toggle */}
                        <IconButton
                            onClick={switchLanguage}
                            sx={{ width: 36, height: 36, borderRadius: '1rem', backgroundColor: '#f1f5f9', color: '#0f172a', border: '1px solid #e2e8f0', '&:hover': { backgroundColor: '#e2e8f0', transform: 'scale(1.05)' } }}
                        >
                            <GlobeIcon />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
        </Drawer>
    );
}
